import { useState, useEffect } from 'react'
import { message } from 'antd'
import bithumbLogo from '../images/summerBlackFriday/bithumb_logo_RGB_orange_가로형.png'

const useSummerBlackFridayModal = () => {
  const [showBulkModal, setShowBulkModal] = useState(false)

  const promotionInfo = {
    title: '올웨이즈 X 빗썸 여름 블랙프라이데이',
    subtitle: 'BITHUMB SUMMER COLLABORATION',
    period: '2025.07.24 ~ 2025.08.14',
    minDiscountRate: 5,
    defaultDiscountRate: 10,
    recommendedDiscountRate: 20,
    commissionRate: 15,
    benefits: [
      '카카오톡 알림 발송',
      '프로모션 이벤트 페이지 노출',
      '특별 배지 부여',
      '특별 띠 배너 노출',
    ],
    bithumbBenefits: {
      logo: bithumbLogo,
      color: '#FF6C00', // 빗썸 주황색으로 수정
    },
  }

  useEffect(() => {
    const checkPromotion = () => {
      const today = new Date()
      const startDate = new Date('2025-07-01')
      const endDate = new Date('2025-08-13')

      // 프로모션 기간 내에 있는지만 확인
      if (today >= startDate && today <= endDate) {
        // 1.5초 후에 원클릭 신청 모달 표시 (페이지 로딩 완료 후)
        setShowBulkModal(true)
      } else {
        setShowBulkModal(false)
      }
    }

    checkPromotion()
  }, [])

  const handleBulkClose = () => {
    setShowBulkModal(false)
  }

  const handleApplicationSuccess = () => {
    message.success(
      '올웨이즈 X 빗썸 여름 블랙프라이데이 프로모션 신청이 완료되었습니다!',
    )
    setShowBulkModal(false)
  }

  return {
    showBulkModal,
    setShowBulkModal,
    promotionInfo,
    handleBulkClose,
    handleApplicationSuccess,
  }
}

export default useSummerBlackFridayModal
